import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { PortfolioView } from '../features/portfolio';
import { ProjectsArchive } from '../features/portfolio/ui/ProjectsArchive';
import { ScrollToTop } from '../shared/lib/ScrollToTop';

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PortfolioView />} />
        <Route path="/projects" element={<ProjectsArchive />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
